const initialState = {
  consultantsList: [],
};

export const consultantsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "consultants")
    return action.execute(state);
  return state;
};
